module.exports = __webpack_public_path__ + "static/img/8.95034c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/2/8.png
// module id = oFei
// module chunks = 0